var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-autocomplete',{staticClass:"auto_complete",attrs:{"size":"small","value":_vm.value,"fetch-suggestions":_vm.querySearchAsync,"placeholder":"请输入内容","clearable":""},on:{"select":_vm.handleSelect,"blur":_vm.checkblur,"clear":_vm.clearInput},model:{value:(_vm.shopname),callback:function ($$v) {_vm.shopname=$$v},expression:"shopname"}})
}
var staticRenderFns = []

export { render, staticRenderFns }